const intervaleList = [
  { label: 'Diario', value: '1d' },
  { label: 'Semanal', value: '1w' },
  // { label: 'Mensual', value: '1M' },
]

const topQuestionnairesList = [
  { label: 'Mejores', value: 1 },
  { label: 'Peores', value: 2 },
]

export { intervaleList, topQuestionnairesList }